import React, { useState } from 'react';

function CreateActivityForm() {
    const [activityDate, setActivityDate] = useState('');
    const [reporter, setReporter] = useState('');
    const [entrapment, setEntrapment] = useState(false);
    const [activityType, setActivityType] = useState('');
    const [referenceNo, setReferenceNo] = useState('');
    const [problem, setProblem] = useState('');
    const [status, setStatus] = useState('');
    const [closedDate, setClosedDate] = useState('');
    const [problemCode, setProblemCode] = useState('');
    const [mechanic, setMechanic] = useState('');
    const [resolution, setResolution] = useState('');

    const labelClass = "block text-xs font-semibold text-slate-400 uppercase tracking-wider mb-1";
    const inputClass = "w-full bg-slate-900/60 border border-slate-600/50 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-cyan-500/50";
    const selectClass = "w-full bg-slate-900/60 border border-slate-600/50 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-cyan-500/50";

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            {/* Two-column grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Left column */}
                <div className="space-y-4">
                    <div>
                        <label className={labelClass}>Device</label>
                        <input type="text" value="Elevator - A #60262" readOnly className={inputClass + " bg-slate-800/80 text-slate-400 cursor-not-allowed"} />
                    </div>
                    <div>
                        <label className={labelClass}>Activity Date</label>
                        <input type="datetime-local" value={activityDate} onChange={(e) => setActivityDate(e.target.value)} className={inputClass} />
                    </div>
                    <div>
                        <label className={labelClass}>Reporter</label>
                        <input type="text" value={reporter} onChange={(e) => setReporter(e.target.value)} className={inputClass} />
                    </div>
                    <div className="flex items-center gap-3">
                        <label className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Entrapment</label>
                        <input type="checkbox" checked={entrapment} onChange={(e) => setEntrapment(e.target.checked)} className="w-4 h-4 rounded border-slate-600 bg-slate-900/60 text-cyan-500 focus:ring-cyan-500/50" />
                    </div>
                    <div>
                        <label className={labelClass}>Activity Type</label>
                        <select value={activityType} onChange={(e) => setActivityType(e.target.value)} className={selectClass}>
                            <option value="">Select</option>
                            <option value="call-back">Call Back</option>
                            <option value="consultant-report">Consultant Report</option>
                            <option value="major-repair">Major Repair</option>
                        </select>
                    </div>
                    <div>
                        <label className={labelClass}>Problem</label>
                        <textarea rows="3" value={problem} onChange={(e) => setProblem(e.target.value)} className={inputClass + " resize-none"} />
                    </div>
                    <div>
                        <label className={labelClass}>Reference No.</label>
                        <input type="text" value={referenceNo} onChange={(e) => setReferenceNo(e.target.value)} className={inputClass} />
                    </div>
                </div>

                {/* Right column — Repair Status */}
                <div className="space-y-4">
                    <h3 className="text-sm font-semibold text-slate-300 uppercase tracking-wider border-b border-slate-700/50 pb-2">Repair Status</h3>
                    <div>
                        <label className={labelClass}>Status</label>
                        <select value={status} onChange={(e) => setStatus(e.target.value)} className={selectClass}>
                            <option value="">Select</option>
                            <option value="open">Open</option>
                            <option value="completed">Completed</option>
                        </select>
                    </div>
                    <div>
                        <label className={labelClass}>Closed Date</label>
                        <input type="datetime-local" value={closedDate} onChange={(e) => setClosedDate(e.target.value)} className={inputClass} />
                    </div>
                    <div>
                        <label className={labelClass}>Problem Code</label>
                        <select value={problemCode} onChange={(e) => setProblemCode(e.target.value)} className={selectClass}>
                            <option value="">Select</option>
                            <option value="brake">Brake</option>
                            <option value="cab">Cab</option>
                            <option value="car-door">Car Door</option>
                        </select>
                    </div>
                    <div>
                        <label className={labelClass}>Mechanic</label>
                        <input type="text" value={mechanic} onChange={(e) => setMechanic(e.target.value)} className={inputClass} />
                    </div>
                    <div>
                        <label className={labelClass}>Resolution</label>
                        <textarea rows="3" value={resolution} onChange={(e) => setResolution(e.target.value)} className={inputClass + " resize-none"} />
                    </div>
                </div>
            </div>

            {/* Save button */}
            <div className="flex justify-end pt-2 border-t border-slate-700/50">
                <button type="submit" className="px-6 py-2.5 bg-cyan-600 hover:bg-cyan-500 text-white text-sm font-semibold rounded-lg transition">
                    Save Activity
                </button>
            </div>
        </form>
    );
}

export default CreateActivityForm;
